import React from "react";

// Shared by Sell Your Product and provider-based seller listings. Callers own
// labels, business validation and values; native constraints stay identical.
const ProductPriceInput = React.forwardRef(({ min = "0", step = "0.01", ...props }, ref) => (
  <input ref={ref} type="number" min={min} step={step} {...props} />
));

export default ProductPriceInput;
